import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';

export const getDrawdownType = (formalOffer: TFormalOffer) => {
    if (formalOffer.is_repayment_reduction) return 'repayment_reduction';
    else if (
        formalOffer.interest_only_repayments &&
        formalOffer.interest_only_repayments > 0 &&
        formalOffer.available_cash === 0
    ) {
        return 'interest_only_extension';
    } else {
        return 'topup';
    }
};
